/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Deep_Tiger_PaceInputs */

const en_warm_deep_tiger_pace = /** @type {(inputs: Warm_Deep_Tiger_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejection failed`)
};

const de_warm_deep_tiger_pace = /** @type {(inputs: Warm_Deep_Tiger_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Rejection failed" |
*
* @param {Warm_Deep_Tiger_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_deep_tiger_pace = /** @type {((inputs?: Warm_Deep_Tiger_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Deep_Tiger_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_deep_tiger_pace(inputs)
	return de_warm_deep_tiger_pace(inputs)
});